import { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const TeamManagementPage = () => import('@/modules/team/pages/TeamManagement/index.vue');

const teamRoutes: Array<RouteRecordRaw> = [
  {
    path: '/team',
    component: MainLayout,
    meta: {
      accessRol: {
        section: 'MANAGE_TEAM',
        actions: ['VIEW_INVITATIONS'],
      },
    },
    children: [
      {
        path: '',
        name: 'team-view',
        component: TeamManagementPage,
      },
    ],
  },
];

export default teamRoutes;
